import env from '../../env.json';

import { METHODS } from '../const/config';

const { BASE_URL_TOURPACKAGE } = env;
// const token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NGUzNTRhOGIzMGVkMzIxODc5YjNjNjEiLCJpYXQiOjE3MTc5OTU0NDYsImV4cCI6MTcxNzk5OTA0Nn0.qeKkYoDNLxnxLclCOQ8l94PAaHId4u4FLxx1myX570g'
// const token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NGUzNTRhOGIzMGVkMzIxODc5YjNjNjEiLCJpYXQiOjE3MTM1MTUzNTYsImV4cCI6MTcxMzUxODk1Nn0.0ZQT0Yfsf1TTdP_dL-RaQH0hsUlLtGlpLK-5fpzr44k'
function joinUrl(url) {
    return BASE_URL_TOURPACKAGE + url;
}

class TourPackageHttp{
    constructor() {
        // assign base url to local variable
        this.baseurl = BASE_URL_TOURPACKAGE;
    }

     // Helper function to get token from localStorage
     static getToken() {
        // Assuming token is stored under the key 'token'
        return localStorage.getItem('token');
    }

   
    static async request(url, method, data) {
        // Get headers before API call
        // const headers =a await getHeaders();
        console.log("data in request ",data)

         // Fetch the token from localStorage
         const token = this.getToken();

         
        // Create options for the API call
        const options = {
            method,
            headers: {
                'Content-Type': 'application/json', // Set Content-Type header to application/json
                'Authorization': `Bearer ${token}`
            },
            // headers,
        };

        // If data add it in to body
        // Stringfy the body
        if (data != null) {
            options.body = JSON.stringify(data);
            console.log("options.body",options.body)
            // console.log("data",data)
        }

        // Return fetch response
        // return fetch(url, options).then(res => {
        //     // console.log("res.json()",res.json())
        //     res.json();
        // });
        try {
            // return fetch(url, options).then(res => res.json());
            console.log("url in http ",url,options)
            const response = await fetch(url, options);
            console.log(
                "response in https",response
            )
            // await  console.log("response in http options",response.json());
            const data = await response.json();
            console.log("response in http data", data);
            return data; // This will return the array
        } catch (err) {
            console.log("error in http", err);
            throw err; // Re-throw the error if needed
        }
      
       

    }



    // Post method
    static async post(url, data = {}) {
        console.log('in Http post ',joinUrl(url), METHODS.POST, data)
        return this.request(joinUrl(url), METHODS.POST, data);
    }
      // Get method
      static async get(url) {
        console.log('in Http get',joinUrl(url), METHODS.GET, )
        return this.request(joinUrl(url), METHODS.GET);
        // return fetch(url, METHODS.GET).then(res => res.json());
    }
     // Update method
     static async update(url, data = {}) {
        console.log("data in http ",data)
        return this.request(joinUrl(url), METHODS.PUT, data);
    }
    // Delete method
    static async delete(url) {
        console.log("url",url)
        return this.request(joinUrl(url), METHODS.DELETE);
    }
}
export default TourPackageHttp;